/* ADA for Searchanise */
$(function () {
  var searchaniseCloseObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') {
        return;
      }

      var previouslyOpen = mutation.oldValue.includes('snize-instant-widget-is-open');
      var currentlyOpen = $(mutation.target).hasClass('snize-instant-widget-is-open');

      if (previouslyOpen && !currentlyOpen) {
        // user closed searchanise widget
        console.log('[Searchanise] Search results closed');
        focusOpenSearchElement();
      } else if (!previouslyOpen && currentlyOpen) {
        // user opened searchanise widget
        console.log('[Searchanise] Search results opened');
        observeSearchResults();
      }
    });
  });
  var body = document.querySelector('body');
  searchaniseCloseObserver.observe(body, {
    attributes: true,
    attributeOldValue: true
  });
  var suggestionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var $suggestions = $(mutation.addedNodes).filter('li.snize-suggestion, li.snize-view-all-link');

      if ($suggestions.length) {
        console.log("[Searchanise] Adding tabindex to ".concat($suggestions.length, " suggestion(s)"));
        $suggestions.wrapInner('<div tabindex="0"></div>').on('keyup', function (evt) {
          if (evt.which === 13) {
            $(evt.currentTarget).trigger('click');
          }
        });
      }
    });
  });

  function observeSearchResults() {
    var elem = document.querySelector('.snize-ac-results');

    if (elem) {
      console.log('[Searchanise] Observing search suggestions in', elem);
      suggestionObserver.observe(elem, {
        childList: true,
        subtree: true
      });
    } else {
      console.warn('[Searchanise] Unable to find the search results div to observe');
    }
  }

  function getFocusableElements(context) {
    return $('input, button, a, *[tabindex="0"]', context).filter(function (idx, elem) {
      return $(elem).css('visibility') === 'visible';
    });
  }

  function focusOpenSearchElement() {
    var focusElem = $('.snize-custom-widget-opener, #bt-snize-search-input').filter(':visible').get(0);
    console.log('[Searchanise] Setting focus to', focusElem);

    if (focusElem) {
      window.setTimeout(function () {
        focusElem.focus();
      }, 0);
    }
  }

  $(document).on('focusin', '#snize-mobile-search-input, #bt-snize-search-input', observeSearchResults).on('focusout', '#snize-mobile-search-input, #bt-snize-search-input', function () {
    console.log('[Searchanise] Disconnecting suggestion observer');
    suggestionObserver.disconnect();
  }).on('click', 'button.snize-clear-button', function (evt) {
    evt.target.type = 'reset';
    var input = document.getElementById('snize-mobile-search-input');
    console.log('[Searchanise] Resetting search term and focus to', input);

    if (input) {
      input.focus();
    }
  }).on('keydown', '.snize-ac-results', function (evt) {
    if (evt.which !== 9) {
      return;
    }

    var $focusElems = getFocusableElements('.snize-ac-results');
    var firstElem = $focusElems.first().get(0);
    var lastElem = $focusElems.last().get(0);
    var $target = $(evt.target);
    var focusElem = null;

    if ($target.is(firstElem) && evt.shiftKey) {
      focusElem = lastElem;
    } else if ($target.is(lastElem) && !evt.shiftKey) {
      focusElem = firstElem;
    }

    if (focusElem) {
      console.log('[Searchanise] Attempting to tab out of search results, setting focus to', focusElem);
      evt.stopPropagation();
      evt.preventDefault();
      focusElem.focus();
    }
  }).on('keydown', '.snize-ac-results', function (evt) {
    if (evt.which !== 27) {
      return;
    }

    console.log('[Searchanise] Esc pressed, closing search results');
    $('#bt-snize-search-input').val('');

    if (window.Searchanise && window.Searchanise.AutocompleteClose) {
      window.Searchanise.AutocompleteClose();
    }

    focusOpenSearchElement();
  }); // eslint-disable-next-line

  $('button.search-bar--submit').on('keydown', function (evt) {
    if (evt.which === 9 && !evt.shiftKey) {
      console.log('[Searchanise] Tab keydown detected on the desktop search button');
      var tabElem = getFocusableElements('.snize-ac-results').get(0);

      if (tabElem) {
        console.log('[Searchanise] Setting focus to first tabbable element in search results', tabElem);
        evt.stopPropagation();
        evt.preventDefault();
        tabElem.focus();
      } else {
        console.log('[Searchanise] No focusable elements exist in search results');
      }
    }
  });
});